jQuery(document).ready(function () {
    $(document).on('change', '.dnJs-showHideOnSelect', function (e) {
        var select = $(this);
        var classSelector = '.' + select.attr('data-classSelector');
        var selectedOption = select.val();

        $(classSelector).each(function() {
            var el = $(this);
            var showHideOnSelectOptions = $(this).attr('data-showHideOnSelectOptions').split(',');

            if (showHideOnSelectOptions.includes(selectedOption)) {
                el.removeAttr('hidden');
            } else {
                el.attr('hidden', 'hidden');
            }
        });
    });
});
